// extracted by mini-css-extract-plugin
export default {"wrapper":"EkXvlOAaQ3yVXLyatP_U","passwordRules":"q8QGctALgrdX_2bIr9Mn","submitBtn":"Iq9XSWZd1uwW2q8ZpUsh"};